import { Form } from "antd";
import React from "react";
import { Select } from "./BaseSelect";
import { PopoverText } from "@/components";

const remainingShippingHoursOptions = [2, 4, 8, 10, 14, 16, 24].map((hours) => ({
    value: hours,
    label: `${hours}小时内`,
}));

const RemainingShippingHoursField: React.FC = () => {
    return (
        <Form.Item
            name="remainingShippingHours"
            label={
                <span className="search-field-label">
                    <PopoverText content="剩余发货时间">发货时限</PopoverText>
                </span>
            }
        >
            <Select allowClear options={remainingShippingHoursOptions} />
        </Form.Item>
    );
};

export default React.memo(RemainingShippingHoursField);
